module.exports = __webpack_public_path__ + "static/media/a la plancha.27873298.svg";